module.exports = __webpack_public_path__ + "static/media/mar_bennasar2-card.133a7ce6.jpg";